<template>
    <section class='goods-item'>
        <div>
            <img :src="mediaUrl(pack)" class="goods_img" alt="">
        </div>
        <div class='sku_info'>
            <div class='sku_name'>{{pack.iname}}</div>
            <div class="content">
                <div class='pack-type'>{{resTypeMap[pack.res_type]}}</div>
                <div>
                    <span v-if="!process.hasTask || (process.hasTask && process.packId!==pack.id)" slot="after"
                          @click.stop="downLoadPack(pack)"> <img src="../../assets/icon_package_download.png"
                                                                 class='icon_package_download' alt=""></span>
                    <span v-else slot="after">
                        <f7-gauge
                                type="circle"
                                :value="process.value/100"
                                :size="30"
                                :borderWidth=2
                                :value-text="`${process.value}%`"
                                :valueFontSize="12"
                                border-color="#28c76f"
                                valueTextColor="#28c76f"
                                value-text-color="#2196f3"
                        ></f7-gauge>
                    </span>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/ecmascript-6">
  import { f7Button, f7Gauge } from 'framework7-vue'
  import {
    globalConst as native,
    LOAD_COMPLATE,
    LOAD_ING,
    LOAD_NO,
    modalTitle,
    RES_TYPE_ZHIJIEDIANDU,
    RES_TYPE_ZHINENGDIANDU,
    RES_TYPE_TIEZHIDIANDU,
    resTypeMap
  } from 'lib/const'
  import { getMediaUrl } from 'lib/common'
  import { mapState, mapGetters } from 'vuex'

  export default {
    props: {
      pack: Object,
      packType: String
    },
    data () {
      return {
        RES_TYPE_ZHIJIEDIANDU,
        RES_TYPE_ZHINENGDIANDU,
        RES_TYPE_TIEZHIDIANDU,
        resTypeMap
      }
    },
    created () {
    },
    methods: {
      downLoadPack (pack) {
        this.$emit('downLoadPack', pack)
      },
      mediaUrl (pack) {
        // http://image-demo.oss-cn-hangzhou.aliyuncs.com/example.jpg?x-oss-process=image/resize,m_pad,h_100,w_100,color_FF0000
        return `${pack.mediaUrl}?x-oss-process=image/resize,m_pad,h_360,w_360`
      },
    },
    computed: {
      ...mapState({
        process: ({downLoader}) => downLoader.process,
        downLoaderServerUrl: ({downLoader}) => downLoader.downLoaderServerUrl
      })
    },
    components: {f7Button, f7Gauge}
  }
</script>
<style lang="scss" scoped type="text/css">
    @import "packItem.scss";
</style>
